// extracted by mini-css-extract-plugin
export var downloadContainer = "Footer-module--downloadContainer--48d55";
export var downloadOurAppHeading = "Footer-module--downloadOurAppHeading--32552";
export var footerContainer = "Footer-module--footerContainer--1d26e";
export var footerYear = "Footer-module--footerYear--fe878";
export var innerContainer = "Footer-module--innerContainer--2e462";
export var innerDownloadContainer = "Footer-module--innerDownloadContainer--5ada9";
export var logoImage = "Footer-module--logoImage--3d36b";
export var ulList = "Footer-module--ulList--0814a";